'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { recoverBlynPathFromWindow } from '@/lib/blynHostRoutes';

export default function RootRedirectPage() {
  const router = useRouter();
  useEffect(() => {
    // CloudFront 404 fallback serves this page for missing `/v2/ai-agent/*.html`.
    // If the address bar is still a Blyn deep link, recover instead of dashboard.
    router.replace(
      recoverBlynPathFromWindow(window.location.pathname, window.location.search) ?? '/dashboard',
    );
  }, [router]);
  return null;
}
